import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Button, FormModel, Input, DatePicker, Select } from "@h3/antd-vue";
import * as utils from "../../../utils/pc/utils";
import WorkflowTree from "./tree_new.vue";
import StaffSelector from "../../../../../form/src/common/components/form-staff-selector/pc/staff-selector.vue";
let PageSelectMotail = class PageSelectMotail extends Vue {
    constructor() {
        super(...arguments);
        this.ruleForm = {
            sequenceNo: "",
            workflowName: "",
            workflowCode: "",
            originatorName: "",
            activityName: "",
            participantName: "",
            time: [],
            instanceState: "",
            participant: "",
        };
        this.params = {
            sourceType: "portal",
        };
        this.staffSelectorOpts = {
            selectOrg: true,
            selectUser: true,
            mulpitle: false,
            showModel: true,
            showSelect: true,
            placeholder: "请选择",
        };
    }
    submitForm() {
        /**
         * 处理筛选条件
         */
        const obj = Object.assign({}, this.ruleForm);
        if (obj.time.length > 0) {
            obj.startTime = utils.timeStampToDate("YY-MM-DD", this.ruleForm.time[0]._d);
            obj.endTime = utils.timeStampToDate("YY-MM-DD", this.ruleForm.time[1]._d);
        }
        delete obj.time;
        this.$emit("search", obj);
    }
    onSelect(nameObj) {
        // @ts-ignore
        this.ruleForm.workflowCode = nameObj.name;
    }
    // resetForm(formName: string) {
    //   /**
    //    * resetFields重置无效
    //    */
    //   Object.keys(this.ruleForm).forEach((key) => (this.ruleForm[key] = ""));
    // }
    /**
     * 重置清空
     */
    clearKeyword() {
        Object.keys(this.ruleForm).forEach((key) => (this.ruleForm[key] = ""));
        this.$emit("search", this.ruleForm);
    }
    close() {
        this.$emit("close");
    }
};
tslib_1.__decorate([
    Prop({ default: true })
], PageSelectMotail.prototype, "isShow", void 0);
tslib_1.__decorate([
    Prop({ default: 1 })
], PageSelectMotail.prototype, "selectType", void 0);
PageSelectMotail = tslib_1.__decorate([
    Component({
        name: "page-select-motail",
        components: {
            AFormModelItem: FormModel.Item,
            AFormModel: FormModel,
            AButton: Button,
            AInput: Input,
            WorkflowTree,
            StaffSelector,
            ARangePicker: DatePicker.RangePicker,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], PageSelectMotail);
export default PageSelectMotail;
